import React from 'react'
import './style.scss'
// import DateTime from 'react-datetime'
class DateTimePicker extends React.Component {
  constructor() {
    super()
  }
  render() {
    return <div>{/* <DateTime {...this.props}/> */}</div>
  }
}

export default DateTimePicker
